<script setup lang="ts">
defineOptions({
  name: 'BannerUpsellCountdown',
})

defineProps<{
  text: string
}>()
</script>

<template>
  <p class="banner-upsell-countdown">
    <span class="banner-upsell-countdown__label btly-text-body-s">Ends in</span>
    <span class="banner-upsell-countdown__time btly-text-title-s md:btly-text-title-m">{{ text }}</span>
  </p>
</template>

<style scoped lang="scss" src="@scss/components/Atoms/UpsellBanner/BannerUpsellCountdown.scss" />
